export default {
  title01: "現在の天気",
  title02: "24時間",
  title03: "10日間の天気予報を見る",
  title04: "空気質指数 (AQI)",
  title05: "すべての情報を見る",
  title06: "日の出と日の入り",
  title07: "月の位相",
  title08: "次の満月",
  title09: "次の新月",
  title10: "昼",
  title11: "夜",
  title12: "日の出",
  title13: "日の入り",
  title14: "月の出",
  title15: "月の入り",
  title16: "ソース",
  title17: "開始",
  title18: "終了",
  title19: "現在地を使用",
  title20: "都市を検索",
  title21: "体感温度",
  title22: "日陰の体感温度",
  title23: "現在",
  title24: "今日",
  title25: "日",
  title26: "月",
  title27: "火",
  title28: "水",
  title29: "木",
  title30: "金",
  title31: "土",
  title32: "読み込み中...",
  title33: "現在",
  title34: "時間ごと",
  title35: "日ごと",
  title36: "太陽と月",
  title37: "空気質",
  title38: "連絡先: xlf550402@gmail.com",
  title39: "プライバシー契約",
  title40: "著作権 © comfortweather.com 2020 - 2026. 無断転載を禁じます。",
  title41: "",
  title42: "高",
  title43: "低",
  title44: "同意する",
  title45: "ComfortWeatherをご利用いただきありがとうございます！ ご自身の法的権利と利益を守るために、ご利用前に ",
  title46: "プライバシーポリシー",
  title47: " をよくお読みください。 ",
  title48: "提供のデータ",
  title49: "連絡先: xyjph123@gmail.com",
  title50: "著作権 © 24hweather.com 2020 - 2026. 無断転載を禁じます。",
  title51: "24hweatherをご利用いただきありがとうございます！ ご自身の法的権利と利益を守るために、ご利用前に ",
  title52: "現在地が変更されました。更新しますか？",
  title53: "確認",
  title54: "キャンセル",
  title55: "戻る",
  title56: "ニュース",
  title57: "天気を更新中...",
  title58: "天気が更新されました",
  title59: "すべて表示",
  title60: "著作権 © mobi321.com 2020 - 2026. 無断転載を禁じます。",
  title61: "昨日",
  title62: "明日",
  title63: "15日間の天気予報を見る",
  title64: "今日の詳細",
  title65: "Rahu Kaal",
  title66: "ライフスタイル指数",
  title67: "ライフスタイル指数",
  title68: "未来7天Rahu Kala时间表",
  title69: "至",
  title70: "至",
  title71: "空气质量指数",

  title102: "乾きにくい",
  title103: "遅い乾燥",
  title104: "よく乾く",
  title105: "速乾",
  title106: "非常に速く乾く",

  title107: "適していない",
  title108: "控えめな体験",
  title109: "水遊びに適している",
  title110: "非常に適している",
  title111: "完璧な条件",

  title112: "健康に良い",
  title113: "中立的な状態",
  title114: "少し高いリスク",
  title115: "高リスク",
  title116: "極端なリスク",

  title117: "適していない",
  title118: "多少適している",
  title119: "屋外活動に適している",
  title120: "非常に適している",
  title121: "優れた条件",

  title122: "非常に乾燥した状態",
  title123: "乾燥している可能性が高い",
  title124: "少し乾燥している",
  title125: "乾燥していない可能性が高い",
  title126: "乾燥していない可能性が非常に高い",

  title127: "おすすめしません",
  title128: "受け入れ可能",
  title129: "良い日",
  title130: "非常に良い条件",
  title131: "理想的な条件",
};
